import React from 'react';
import { useCountUp } from '../../hooks/useCountUp';

function AnimatedCounter({ end, suffix = '', prefix = '', duration = 2000 }) {
    const [ref, count] = useCountUp(end, duration);

    return (
        <span ref={ref} className="text-5xl md:text-6xl font-bold text-[#FFC000] mb-2 tabular-nums">
            {prefix}{count.toLocaleString()}{suffix}
        </span>
    );
}

export default AnimatedCounter;